import { useState } from 'react'
import { Box, Grid } from '@mui/material'
import { ImageCapture } from './ImageCapture'
import { Button, Divider } from '@fullscreendigital/carrefour-dex-fe'
import { ImagesList } from './ImagesList'
import s from 'components/core-ui/Modal/Modal.modules.scss'

export interface DocumentFormProps {
  cancelModal: (event: React.MouseEvent<HTMLElement>) => void
  addDocument: (images: File[]) => void
  accept?: string
  documentType?: AutocompleteOption
  saveData?: () => void
}

const DocumentForm = (props: DocumentFormProps) => {
  const { cancelModal, addDocument, accept, documentType, saveData } = props

  const [images, setImages] = useState([])
  const [showPhotoCapture, setShowPhotoCapture] = useState(false)

  const saveFiles = () => {
    addDocument(images)
    setImages([])
  }

  const deleteImage = (image: File) => {
    const newImages = images.filter(img => img !== image)
    setImages(newImages)
  }

  return (
    <>
      <Box>
        <ImageCapture
          images={images}
          setImages={setImages}
          showPhotoCapture={showPhotoCapture}
          setShowPhotoCapture={setShowPhotoCapture}
          accept={accept}
        />
        {!showPhotoCapture && (
          <>
            <Divider component="div" style={{ margin: '24px 0' }} />
            <ImagesList images={images} deleteImage={deleteImage} />
          </>
        )}
      </Box>
      <Grid container spacing={4}>
        <Grid xs={12} item className={s.modalButtons}>
          <Button variant="outlined" label="Anuleaza" onClick={cancelModal} />
          <Button
            variant="contained"
            type="submit"
            label="Salveaza"
            onClick={saveFiles}
            disabled={!images.length}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default DocumentForm
